<template>
  <div id="starters-container">
    <div v-if="!isSmallResults" id="x-container" @click="closeChatStarters">
      <div class="x-line r-right"></div>
      <div class="x-line r-left"></div>
    </div>
    <button v-for="(starter, index) in starters" @click="starterClicked(starter.message)" :key="index" class="chat-starter large-reg">
      <span class="starter-text">{{ starter.displayText }}</span>
    </button>
  </div>
</template>
  
<script setup>
import { useMessagesStore } from '@/stores/useMessagesStore';
import { useWindowStateStore } from '@/stores/useWindowStateStore';
import { useChatStartersStore } from '@/stores/useChatStartersStore';
import { storeToRefs } from 'pinia';

const { starters } = storeToRefs(useChatStartersStore());
const { sendMsg } = useMessagesStore();
const { toggleChatWindow, hideChatStarters } = useWindowStateStore();

/**
 * Send message, hide starters, show chat window when starter clicked
 * @param {string} starter 
 */
function starterClicked(message) {
  toggleChatWindow();
  if (!message) return;
  if (message == 'Text me!') {
    sendMsg(message, 'request_contact');
  } else {
    sendMsg(message);
  }
}

function closeChatStarters() {
  hideChatStarters();
}
</script>

<style scoped>
#starters-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
}

.chat-starter {
  padding: 10px 20px 10px 20px;
  background-color: var(--black-default);
  margin-bottom: 15px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  color: var(--white-default);
  text-align: left;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.15);
  max-width: 300px;
}

.starter-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
}

.x-line {
  height: 12px;
  width: 1px;
  border-radius: 1px;
  background-color: var(--black-default);
  position: absolute;
  top: 50%;
  left: 50%;
}

.r-right {
  transform: translate(-50%, -50%) rotate(45deg);
}

.r-left {
  transform: translate(-50%, -50%) rotate(-45deg);
}

#x-container {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid var(--black-default);
  background-color: var(--white-dark);
  box-sizing: border-box;
}
</style>
  